import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { useCallback, useEffect, useRef, useState } from 'react';
export var useTypewriter = function useTypewriter(text) {
  var baseSpeed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10;
  var skip = arguments.length > 2 ? arguments[2] : undefined;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    displayText = _useState2[0],
    setDisplayText = _useState2[1];
  var timeoutRef = useRef(null);
  var calculateSpeed = useCallback(function (textLength) {
    if (textLength > 1000) {
      return baseSpeed * 0.01;
    } else if (textLength > 500) {
      return baseSpeed * 0.05;
    } else if (textLength > 200) {
      return baseSpeed * 0.3;
    } else if (textLength > 100) {
      return baseSpeed * 0.8;
    }
    return baseSpeed;
  }, [baseSpeed]);

  // biome-ignore lint/correctness/useExhaustiveDependencies: dependencies are intentional
  useEffect(function () {
    setDisplayText('');
    // biome-ignore lint/style/useBlockStatements: single-line early return
    if (!text || skip) return;
    var speed = calculateSpeed(text.length);
    var queue = _toConsumableArray(text);
    var typingInterval = setInterval(function () {
      if (queue.length > 0) {
        setDisplayText(function (prevText) {
          return prevText + queue.shift();
        });
      } else {
        clearInterval(typingInterval);
      }
    }, speed);
    var currentTimeoutRef = timeoutRef.current;
    return function () {
      clearInterval(typingInterval);
      // biome-ignore lint/style/useBlockStatements: single-line early return
      if (currentTimeoutRef) clearTimeout(currentTimeoutRef);
    };
  }, [text, skip, baseSpeed, calculateSpeed]);
  return (skip ? text : displayText) || '';
};